import * as React from 'react';

const LogoAppleSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.012 2c-.997.046-2.222.679-2.947 1.516-.658.747-1.224 1.946-1.066 3.099 1.112.09 2.267-.565 2.97-1.402.704-.86 1.18-2.036 1.043-3.213zm-.022 4.842c-1.564-.16-3.06.927-3.854.927s-2.019-.905-3.311-.882c-1.7.045-3.265.995-4.15 2.51-1.746 3.077-.43 7.602 1.293 10.09.838 1.199 1.859 2.579 3.174 2.51 1.27-.044 1.746-.813 3.288-.813 1.52 0 1.973.814 3.31.791 1.36-.022 2.223-1.244 3.062-2.465.975-1.403 1.36-1.923 1.383-1.991-.022-.023-2.653-1.878-2.698-4.887-.023-2.534 2.063-3.755 2.177-3.823-1.18-1.718-3.016-1.945-3.674-1.967z"
            fill="#4B4D63"
        />
    </svg>
);

LogoAppleSvg.displayName = 'LogoAppleSvg';
export default LogoAppleSvg;
